import surveyService from "../../services/surveyService";
import responseService from "../../services/responseService";
import stakeholderService from "../../services/stakeholderService";

import { getField, updateField } from "vuex-map-fields";

const state = {
  filter: false,
  surveys: [],
  responses: [],
  stakeholders: [],
  showStakeholderCard: false,
  selectedFilterOptions: {},
  selectedSurveyForResponses: null,
  filteredResponsesBasedFilterOptions: []
};

const getters = {
  getField,
  surveys: state => {
    return state.surveys;
  }
};

const actions = {
  fetchSurveys({ commit }) {
    surveyService.fetchData().then(surveys => {
      commit("UPDATE_SURVEYS", surveys);
    });
  },
  fetchResponses({ commit }) {
    responseService.fetchResponses().then(responses => {
      commit("UPDATE_RESPONSES", responses.data);
    });
  },
  fetchStakeholders({ commit }) {
    stakeholderService.fetchStakeholders().then(stakeholders => {
      commit("UPDATE_STAKEHOLDERS", stakeholders);
    });
  },
  updateSelectedSurveyForResponses({ commit }, survey) {
    commit("UPDATE_SELECTED_SURVEY_FOR_RESPONSES", survey);
  },
  updateSelectedFilterOptions({ commit }, filterOptions) {
    commit("UPDATE_SELECTED_FILTER_OPTIONS", filterOptions);
  },
  updateFilteredResponsesBasedOnFilterOptions({ commit }, filterOptions) {
    commit("UPDATE_FILTERED_RESPONSES_BASED_ON_FILTER_OPTIONS", filterOptions);
  },
  setFilter({ commit }, status) {
    commit("SET_FILTER", status);
  },
  toggleStakeholderCard({ commit }, status) {
    commit("TOGGLE_STAKEHOLDER_CARD", status);
  }
};

const mutations = {
  updateField,
  UPDATE_SURVEYS(state, surveys) {
    state.surveys = surveys;
  },
  UPDATE_RESPONSES(state, responses) {
    state.responses = responses;
  },
  UPDATE_STAKEHOLDERS(state, stakeholders) {
    state.stakeholders = stakeholders;
  },
  UPDATE_SELECTED_SURVEY_FOR_RESPONSES(state, survey) {
    state.selectedSurveyForResponses = survey;
  },
  UPDATE_SELECTED_FILTER_OPTIONS(state, filterOptions) {
    state.selectedFilterOptions = filterOptions;
  },
  UPDATE_FILTERED_RESPONSES_BASED_ON_FILTER_OPTIONS(state, filteredResponsesBasedFilterOptions) {
    state.filteredResponsesBasedFilterOptions = filteredResponsesBasedFilterOptions;
  },
  SET_FILTER(state, status) {
    state.filter = status;
  },
  TOGGLE_STAKEHOLDER_CARD(state, status) {
    state.showStakeholderCard = status;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
